import { render, staticRenderFns } from "./SpedizioniCards.vue?vue&type=template&id=ee598296"
import script from "./SpedizioniCards.vue?vue&type=script&lang=ts"
export * from "./SpedizioniCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee598296')) {
      api.createRecord('ee598296', component.options)
    } else {
      api.reload('ee598296', component.options)
    }
    module.hot.accept("./SpedizioniCards.vue?vue&type=template&id=ee598296", function () {
      api.rerender('ee598296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SpedizioniCards.vue"
export default component.exports